import React, { useEffect, useState, useRef, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import { Link } from "react-router-dom";
import TicketStatusBadge from "../../Components/TicketStatusBadge";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListTikets(props) {
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const [ticketsTemp, setTicketsTemp] = useState();
  const [tickets, setTickets] = useState();
  let history = useHistory();
  const [userId, setUserId] = useState(query.get("userId"));

  useEffect(() => {
    const newUserId = query.get("userId");
    if (newUserId !== userId) {
      setUserId(newUserId); // Imposta userId se cambia nella query string
    }
  }, [query]); // Dipendenza su query per aggiornarlo se cambia

  useEffect(() => {
    if (apiToken) {
      if (userId) {
        Repo.getTicketsUser(apiToken, userId)
          .then((response) => {
            if (response.status === 200) {
              setTicketsTemp(response.data);
            }
          })
          .catch((error) => {
            console.error("Errore nel recupero ticket:", error);
          });
      } else {
        Repo.tuttiTicketAperti(apiToken) // Chiamata alternativa se userId non è presente
          .then((response) => {
            if (response.status === 200) {
              setTicketsTemp(response.data);
            }
          })
          .catch((error) => {
            console.error("Errore nel recupero di tutti i ticket:", error);
          });
      }
    }
  }, [apiToken, userId]);

  return (
    <>
      <h1>Gestione ticket</h1>
      <div className="row">
        <div className="col-lg-8">
          <p>
            Qui puoi visualizzare e gestire le richieste di assistenza. Puoi
            controllare lo stato di ogni ticket, aggiungere dettagli o
            aggiornamenti e chiudere le segnalazioni risolte.
          </p>
        </div>

        <div className="col-lg-4 col-md-12 text-right">
          <button
            type="button"
            className="btn btn-outline-primary m-2"
            onClick={() => window.history.back()}
          >
            <span className="align-middle">Indietro</span>
          </button>

          {userId && (
            <button
              type="button"
              className="btn btn-outline-success justify-content-end"
              onClick={() =>
                (window.location.href =
                  window.location.pathname + "/dettaglio?userId=" + userId)
              }
            >
              <svg className="icon icon-success">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              <span className="align-middle">Nuovo Ticket</span>
            </button>
          )}
        </div>
      </div>

      {ticketsTemp && ticketsTemp.length > 0 ? (
        <>
<hr/>
                <div className="row mb-2">
                  <div className="col-2">
                    <strong>Data</strong>
                  </div>
                  <div className="col-3">
                    <strong>Cittadino</strong>
                  </div>

                  <div className="col-2">
                    <strong>Lavorazione</strong>
                  </div>
                  <div className="col-1">
                    <strong>Tag</strong>
                  </div>
                  <div className="col-2">
                    <strong>Operatore</strong>
                  </div>
                  <div className="col-2 text-right"></div>
                </div>
                {ticketsTemp.map((ticket) => (
                  <div className="row mb-1" key={ticket.id}>
                    <div className="col-2">
                      <strong>{ticket.dataApertura}</strong>{" "}
                      <TicketStatusBadge stato={ticket.stato} />
                    </div>
                    <div className="col-3">{ticket.richiedente}</div>

                    <div className="col-2">{ticket.ultimoAggiornamento}</div>
                    <div className="col-1">{ticket.categoria}</div>
                    <div className="col-2">{ticket.assegnatoA}</div>
                    <div className="col-2 text-right">
                      {!userId && (
                        <Link
                          to={`/lista_utenti/dati_utente?citizen=${ticket.userId}`}
                        >
                          <button
                            className="btn btn-outline-primary p-1 mr-1"
                            title={`${ticket.richiedente} Utente`}
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-user`} />
                            </svg>
                          </button>
                        </Link>
                      )}

                      <Link
                        to={
                          "/lista_utenti/dati_utente/ticket/dettaglio?id=" +
                          ticket.id
                        }
                      >
                        <button
                          className="btn btn-outline-primary p-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Dettaglio"
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-search`} />
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}

        </>
      ) : (
        <>
          <div className="alert alert-success mt-2" role="alert">
            <strong>Bene! </strong> Non ci sono segnalazioni di questo utente!
          </div>
        </>
      )}
    </>
  );
}

export default ListTikets;
